import './OfferApproveToStageTwo.scss';
import React, { useEffect, useMemo, useState } from 'react';
import Button from '@atoms/Button';
import clsx from 'clsx';
import { MdClose } from 'react-icons/md';
import Modal from '@atoms/Modal';
import { IOffer } from '@models/winnerSelection/ITableDemand';
import { Controller, useForm } from 'react-hook-form';
import { IOption } from '@/types';
import { WinnerSelectionService } from '@services/WinnerSelectionService';
import { sendNotification } from '@molecules/Notifications';
import Hint from '@atoms/Hint';
import { IOfferApproveToStageTwoFormData } from './IOfferApproveToStageTwoFormData';
import FormProviderControl from '@controls/FormProviderControl';
import HookFormProvider from '@controls/HookFormProvider';
import SelectControl from '@controls/SelectControl';

export interface IOfferApproveToStageTwoProps {
    tableKey: string;
    isEdit: boolean;
    value: IOffer;
    demandId: string;
    onSubmit?: (value: IOfferApproveToStageTwoFormData) => void;
    onClose?: () => void;
}

const OfferApproveToStageTwo = ({
    tableKey,
    isEdit,
    value,
    demandId,
    onSubmit,
    onClose,
    ...props
}: IOfferApproveToStageTwoProps) => {
    const [error, setError] = useState<string>();
    const methods = useForm<IOfferApproveToStageTwoFormData>({
        mode: 'onBlur',
    });

    const { isSubmitting, isDirty } = methods.formState;

    useEffect(() => {
        const defaultValue: IOfferApproveToStageTwoFormData = {
            approveToStageTwo: value.approveToStageTwo,
        };
        methods.reset(defaultValue);
    }, [value]);

    const onClickClose = (e: any) => {
        onClose && onClose();
    };

    const onFormSubmit = async (form: IOfferApproveToStageTwoFormData) => {
        setError(undefined);
        return WinnerSelectionService.saveTableDemandOfferApproveToStageTwo(value.key, demandId, tableKey, form)
            .then((response) => {
                sendNotification({
                    message: 'Данные успешно сохранены',
                    variant: 'green',
                });
                onSubmit && onSubmit(form);
            })
            .catch((reason) => {
                setError(reason);
                console.log(reason);
            });
    };

    const results = useMemo(() => {
        return [
            { label: 'Допущен', value: 1 },
            { label: 'Не допущен', value: 0 },
        ] as IOption[];
    }, []);

    const errorLabel = error && (
        <div className="offer-st2__error">
            <Hint title={error} variant="red" />
        </div>
    );

    const ModalHeader = ({ onClose }: { onClose: (e: any) => void }) => (
        <div className={clsx('offer-st2-modal__header')}>
            <div className={clsx('offer-st2-modal__header-text')}>
                <span>{`Допуск ко второму этапу предложения №${value.number || ''} (${value.name})`}</span>
            </div>
            <div className={clsx('offer-st2-modal__header-close')}>
                <Button
                    buttonType="text"
                    textColor="neutral"
                    size="xs"
                    aria-label="Закрыть окно"
                    onClick={onClose}
                    startAdornment={<MdClose size="24" />}
                />
            </div>
        </div>
    );

    const ModalFooter = () => (
        <div className={'modal-dlg-buttons'}>
            <Button
                type="submit"
                form="offer-st2-form"
                preloader={isSubmitting}
                className={clsx('offer-st2__button', 'offer-st2__save-button')}
                disabled={isSubmitting || !isDirty}
            >
                Сохранить
            </Button>
        </div>
    );

    return (
        <Modal size="m" header={<ModalHeader onClose={onClickClose} />} footer={isEdit ? <ModalFooter /> : null}>
            {errorLabel}
            <FormProviderControl
                formMethods={methods}
                id="offer-st2-form"
                className="offer-st2__form"
                onSubmit={onFormSubmit}
            >
                <HookFormProvider controller={Controller}>
                    <div className="offer-st2__content">
                        <div className="offer-st2__row">
                            <SelectControl
                                label="Допуск ко второму этапу"
                                name="approveToStageTwo"
                                readOnly={true}
                                disabled={!isEdit}
                                highlightMenuItems={false}
                                options={results}
                                formState={methods.formState}
                                control={methods.control}
                                required={true}
                                rules={{ required: 'Обязательное поле' }}
                                setValue={(options) => {
                                    return options[0].value;
                                }}
                                getValue={(options: IOption[], value: any) => {
                                    return options.filter((x) => x.value === value);
                                }}
                            />
                        </div>
                    </div>
                </HookFormProvider>
            </FormProviderControl>
        </Modal>
    );
};

export default OfferApproveToStageTwo;
